export class RouterConstants {
    static readonly SELECT_LANGUAGE_LINK = '/select-language';
    static readonly CREAT_ACCOUNT_LINK = '/create-Account';
    static readonly RESET_PASSWORD_LINK = '/reset-Password';
    static readonly HOME_PAGE_LINK = '/home';
    static readonly LOGIN_PAGE_LINK = '/login';
    static readonly CONFIRM_REGISTRATION_LINK = '/confirm-registration';
    static readonly FORGOT_PWD_LINK = '/forgot-Password';
    static readonly NEW_PWD_LINK = '/new-password';
    static readonly ASSET_LIBRARY_LINK = '/asset-library';
    static readonly EMAIL_SENT_LINK = '/email-sent';
    static readonly PROFILES_LINK = '/profile';
    static readonly STORES_LINK = '/stores';
    static readonly CREATE_PROFILE_LINK = '/profile/create';
    static readonly LANDING_HOME = '/home/landingHome';
    static readonly ACCOUNT_CREATED_LINK = '/account-created';
    static readonly USERS_RETAIL_LINK = '/users/retailhqs';
    static readonly EDIT_PROFILE = '/profile/edit';
    static readonly EDIT_SKU = '/oem/edit';

    static readonly ACTIVE_USERS_LINK = '/users/activeusers';
    static readonly MY_ACCOUNT_LINK = '/my-account';
    static readonly DEVICE_DASHBOARD_LINK = '/devices/device-dashboard';
    static readonly DEVICE_SETTINGS = '/devices/device-settings';
    static readonly DEVICE_STORE_LOGO = '/devices/device-store-logo'
    static readonly HELP_LINK = '/help';
    static readonly CHANGE_LANGUAGE_LINK = '/change-language';
    static readonly STANDARD_DOWNLOAD = '/standard-download';
    static readonly SLASH = '/';
    static readonly OEM_LINK = '/oem';
    static readonly MODEL_SKU_INFO_LINK = '/oem/model-sku-info';
    static readonly CREATE_PARTNER_CONTENT_LINK = '/oem/create-partner-content';
    static readonly CREATE_MODEL_SKU_INFO = '/oem/create-model-sku-info';
    static readonly REVIEW_PARTNERS_LINK = '/partner-content/review-partner-content';
    static readonly CREATE_NEW_PARTNER_CONTENT = '/oem/new-partner-content';
    static readonly OEM_HOME_LINK = '/oem/model-sku-info';
    static readonly ATTRACTOR_LOOP_LINK = '/oem/attractor-loop';
    static readonly SKU_IDS_LINK = '/sku-ids/';
    static readonly GAME_DEMOS_LINK = '/game-demos';
    static readonly REGIONAL_HQ = 'regionalHQ';
}
